// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"501":"427cd189db0608eb","2121":"acbccb87c968f9d5","2748":"c7b066ccfd324f69","2831":"6140728341742e96","3379":"3315650059b13849","8974":"0fc7539152d31cde"}[chunkId] + ".js";
};